import { AxiosResponse } from 'axios';

import { getAuthToken } from '../utils/commonHelper';
import { IPermissionRequestsResponse, ITableRequestData } from '../types/common';
import { toast } from 'react-toastify';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/permission`; // Replace with your actual API URL


const customHeaders = {
    'content-type': 'application/json',
};



export const getPermissionTableService = async ({ limit, page }: ITableRequestData): Promise<AxiosResponse<IPermissionRequestsResponse>> => {
    try {
        let url = `${API_URL}`;

        if (limit !== undefined && page !== undefined) url += `?limit=${limit}&page=${page}`;


        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

